import StarsRow from '@apps/ApplicationRating/widgets/StarsRow'
import { F_RATING_SYSTEM, F_VERSION_SELECTOR } from '@common/featureFlags/access'
import CheckAccess from '@common/featureFlags/CheckAccess'
import { useAppSelector, useTranslate } from '@common/hooks'
import prepareAppDate from '@common/utils/prepareAppDate'
import ApplicationStatus from '@common/widgets/ApplicationStatus'
import HackathonStatus from '@common/widgets/HackathonStatus'
import cx from 'classnames'
import { useRouter } from 'next/router'

import classNames from './styles.module.scss'


interface IProps {
  application: IApplication,
  children: JSX.Element,
}

export default function AppInfo({ application, children }: IProps): JSX.Element {
  const { translate, interpolate } = useTranslate()
  const router = useRouter()

  const ratingAvg = useAppSelector(store => store.applicationRating.data?.app.ratingAvg)
  const total = useAppSelector(store => store.applicationRating.data?.app.ratingScores.reduce((acc, curr) => acc + curr, 0))

  const handleOpenReview = () => {
    void router.push(`/apps/${application.slug || application.id}/reviews`, undefined, { shallow: true })
  }

  return (
    <>
      <h1 className={classNames.title} data-test="app-name">
        <span className={classNames.name}>{application.name}</span>
        <ApplicationStatus application={application} className={classNames.appStatus} showReason/>
        <HackathonStatus appId={application.id}/>
      </h1>
      <div className={classNames.subtitleContainer}>
        <div className={classNames.author} data-test="app-author">
          {translate('by')}
          <span className={cx(classNames.bold, classNames.authorName)}> {application.latest.author}</span>
            <CheckAccess access={F_RATING_SYSTEM}>
              <>
                {ratingAvg && total
                  ? <div className={classNames.reviewRow} onClick={handleOpenReview}>
                      <StarsRow value={ratingAvg} className={classNames.stars}/>
                      <span className={classNames.reviewCount} data-test="rating-count">
                        {total === 1 ? translate('1 rating') : interpolate(translate('%s ratings'), [total])}
                      </span>
                    </div>
                  : null
                }
              </>
            </CheckAccess>
        </div>
        <div className={classNames.rightNav}>
          <CheckAccess access={F_VERSION_SELECTOR}
            fallback={(
              <p className={classNames.version} data-test="settings-app-version">
                {interpolate(translate('Version %s'), [application.latest.version])}
              </p>
            )}
          >
            <p className={cx(classNames.version, classNames.withSelect)} data-test="settings-app-version">
              {interpolate(translate('Version %s'), [''])}
              {children}
            </p>
          </CheckAccess>
          <div data-test="last-updated">
            <span className={classNames.bold}>{translate('Updated')} </span>
            {prepareAppDate(application.latest.created)}
          </div>
        </div>
      </div>
    </>
  )
}
